const flights = {
  flight: "航班", // translated
  flights: "航班", // translated
  originDepartureDate: "离开", // translated
  destinationDepartureDate: "返回", // translated
  outbound: "出境", // translated
  inbound: "入境", // translated
  travelTime: "旅行时间", // translated
  selected: "已选择", // translated
  select: "选择", // translated
  airline: "航空公司", // translated
  directFlight: "直达航班", // translated
  baggage: "行李", // translated
  stops: "停靠点", // translated
  nonStop: "马不停蹄", // translated
  oneStopMax: "最多一站", // translated
  twoStopsMax: "最多两站", // translated
  anyStops: "任何停靠站", // translated
  smallBaggage: "小件行李", // translated
  bigBaggage: "大件行李", // translated
  smallAndBigBaggage: "小行李和大行李", // translated
  outboundStops: "出站站点", // translated
  inboundStops: "进站停靠点", // translated
  selectAirline: "选择航空公司", // translated
  baggageOption: "行李选项", // translated
  outboundDepartureAfter: "出境出发时间为", // translated
  outboundArrivalAfter: "出境到达时间晚于", // translated
  inboundDepartureAfter: "入境出发时间晚于", // translated
  inboundArrivalTimeAfter: "入境到达时间晚于", // translated
  flightClass: "飞行等级", // translated
  outboundDepAfter: "之后出发", // translated
  outboundArrivalAfrer: "外出抵达时间后", // translated
  inboundDepAfter: "出发后", // translated
  inboundArrivalAfter: "抵达后", // translated
  airlines: "航空公司", // translated
  lessThan: "少于", // translated
  layover: "中途停留", // translated
  duration: "期间", // translated
  economy: "经济", // translated
  business: "商业", // translated
  with: "和", // translated
  without: "没有", // translated
  twoOrMore: "两个或更多", // translated
  departure: "离开", // translated
  return: "返回", // translated
  submit: "提交", // translated
  priceLessThan: "价格低于", // translated
  durationLessThan: "持续时间小于", // translated
  layoverLessThan: "中转时间少于", // translated
  noLayover: "无需中转", // translated
  durationLowestFirst: "持续时间（从低到高）", // translated
  durationHighestFirst: "持续时间（从高到低）", // translated
  idType: "身份证类型", // translated
  idPassportCode: "身份证/护照代码", // translated
  expirationDate: "截止日期", // translated
  frequentFlyerNumber: "飞行常客号码", // translated
  frequentFlyerAirline: "飞行常客航空公司", // translated
  dateOfBirth: "出生日期", // translated
  infant: "婴儿", // translated
  phone: "电话", // translated
  title: "标题", // translated
  noLuggageIncluded: "不含行李", // translated
  includesLuggage: "包括行李", // translated
  outboundFlight: "离港航班", // translated
  inboundFlight: "进港航班", // translated
  flightNumber: "航班号", // translated
  flightNumbers: "航班号", // translated
  cabinClassType: "舱位类型", // translated
  aircraftType: "飞机类型", // translated
  airlineName: "航空公司名称", // translated
  no: "不", // translated
  yes: "是的", // translated
  anyFlights: "任何航班", // translated
  oneStop: "1站", // translated
  direct: "直接的", // translated
  directFlights: "直飞航班", // translated
  all: "全部", // translated
  first: "第一的", // translated
  premiumEconomy: "总理。经济", // translated
  withBaggageOnly: "仅携带行李", // translated
  oneWay: "单程", // translated
  roundTrip: "往返", // translated
  withBaggage: "携带行李", // translated
  noBaggage: "无行李", // translated
  requiredFields: "必填字段", // translated
  nonRequiredFields: "非必填字段", // translated
  cabinClass: "舱位等级", // translated
  brandName: "品牌", // translated
  performNewSearch: "执行新的搜索", // translated
  outboundDeparture: "去程出发", // translated
  inboundDeparture: "入境 出发", // translated
  created: "创建时间", // translated
  freeCancellationAvailable: "可免费取消", // translated
  freeCancellationDeadline: "免费取消期限", // translated
  externalReference: "外部参考", // translated
  outboundflightNumber: "去程航班号", // translated
  inboundflightNumber: "进港航班号", // translated
  arrival: "到达", // translated
};

export default flights;
